import { gql } from '@apollo/client';

import { CourseProfessor } from '../../types';
import { courseProfessorFragment } from '../fragments';

export interface GetCourseProfessorsQueryVariables {
  courseId: string;
}

export interface GetCourseProfessorsQueryResult {
  courseProfessors: CourseProfessor[];
}

export const getCourseProfessorsQuery = gql`
  query GetCourseProfessorsQuery($courseId: String!) {
    courseProfessors(courseId: $courseId) @rest(type: "CourseProfessor", path: "courses/{args.courseId}/professors") {
      ...CourseProfessor
    }
  }
  ${courseProfessorFragment}
`;
